module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingResult/images/landing-result-award.0061d88a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingResult/images/landing-result-award.png
// module id = 3141
// module chunks = 11